/* jshint forin:true, noarg:true, noempty:true, eqeqeq:true, bitwise:true, strict:true, undef:true, unused:true, browser:true, devel:true, jquery:true, indent:4, maxerr:50, boss:true, trailing:true, white:true, sub:true*/
/* globals Drupal: true */

(function ($) {
  'use strict';

  Drupal.behaviors.EsteeStoriesLanding = {
    attach: function () {
      // DOM
      var $window = $(window);
      var $filters = $('.es-landing__filter-link');
      var $subfiltersContainer = $('.es-landing__sub-filters');
      var $subfilters = $subfiltersContainer.find('a');
      var $landingTiles = $('.ee-landing__tile');
      var $side_filters_wrapper = $('.es-landing__filters__side__wrapper');
      var $pc__carousel_logo = $('.ee-slick-carousel__logo');
      var $backtoTop = $('.section-esteestories').find('.back-to-top');
      // LOGIC
      var animatingHide = false;
      var animatingShow = false;

      function updateGallery() {
        $landingTiles.removeClass('center');

        // Go through unhidden, potential pairs and add the center class if applicable
        $landingTiles.not('.hidden').not('.ee-landing__tile--large').each(function () {
          // DOM
          var $this = $(this);
          var $next = $this.nextUntil('.ee-landing__tile:not(.hidden)').last().next(); // ('.ee-landing__tile--small, .ee-landing__tile--med');
          var $prev = $this.prevUntil('.ee-landing__tile:not(.hidden)').last().prev(); // ('.ee-landing__tile--small, .ee-landing__tile--med');
          // LOGIC
          var needsCentered = true;
          var currentOffset = $this.offset().top;
          var nextOffset;
          var prevOffset;

          if ($next.length !== 0) {
            nextOffset = $next.offset().top;
          } else {
            $next = $this.next();

            if ($next.length !== 0) {
              nextOffset = $next.offset().top;
            }
          }

          if ($prev.length !== 0) {
            prevOffset = $prev.offset().top;
          } else {
            $prev = $this.prev();

            if ($prev.length !== 0) {
              prevOffset = $prev.offset().top;
            }
          }

          // Mismatched offsets, potentially standalone and needs offset
          if (typeof prevOffset !== 'undefined' && prevOffset === currentOffset) {
            needsCentered = false;
          }

          // Mismatched offsets, potentially standalone and needs offset
          if (typeof nextOffset !== 'undefined' && nextOffset === currentOffset) {
            needsCentered = false;
          }

          if (needsCentered) {
            $this.addClass('center');
          }
        });
      }

      // Animates show for elements to show
      // Animates hide for elements to hide
      function showHide($toShow, $toHide) {
        animatingHide = true;
        animatingShow = true;

        if (typeof $toHide !== 'undefined' || $toHide.length === 0) {
          $toHide.addClass('hidden');
        }

        $landingTiles.fadeOut(500).promise().done(function () {
          animatingHide = false;

          if (typeof $toShow === 'undefined' || $toShow.length === 0) {
            animatingShow = false;
          } else {
            $toShow.removeClass('hidden').css({
              opacity: 0,
              display: 'block'
            });
            updateGallery();
            $toShow.fadeTo(500, 1).promise().done(function () {
              animatingShow = false;
            });
          }
        });
      }

      // BEGIN: Init
      {
        $landingTiles.addClass('hidden');
        showHide($landingTiles, $());
      }
      // END: Init

      // Open up the subfilters below the filter list
      $filters.on('click', function (e) {
        // DOM
        var $this = $(this);
        var $toShow = $();
        var $toHide = $();
        // LOGIC
        var currentID = $this.data('filter-id');

        e.preventDefault();

        // Do not run if animation is still running
        if (animatingShow || animatingHide) {
          return;
        }

        // All Tiles
        if (currentID === 'ee-term-all' && $this.hasClass('term-active')) {
          return false;
        }
        // Unhide all tiles
        else if ($this.hasClass('term-active')) {
          $filters.removeClass('term-active').first().addClass('term-active');

          $subfiltersContainer.find('ul').removeClass('active');
          $('.mobile_sub-filters').removeClass('active');

          $toShow = $landingTiles;
        }
        // Display tiles under main filter
        else {
          $filters.not(this).removeClass('term-active');
          $('[data-filter-id="' + currentID + '"]').addClass('term-active');

          $subfiltersContainer.find('ul').removeClass('active');
          $('.mobile_sub-filters').removeClass('active');

          $('.es-landing__sub-filters .' + currentID).addClass('active');
          $('.mobile_sub-filters.' + currentID).addClass('active');

          // Unhide all tiles
          if (currentID === 'ee-term-all') {
            $toShow = $landingTiles;
          } else {
            $toShow = $('.ee-landing__tile.' + currentID);
          }

          if (currentID === 'es-term5') {
            // Special feature for video tiles
            $landingTiles.each(function () {
              // DOM
              var $this = $(this);
              // LOGIC
              var regex = /es-term5_/;

              if (regex.test($this.attr('class'))) {
                $toShow = $toShow.add($this);
              }
            });
          }

          $toHide = $landingTiles.not($toShow);
        }

        showHide($toShow, $toHide);
      });

      // trigger mobile filter button
      $('.mobile-trigger a').on('click', function (e) {
        e.preventDefault();

        $('.es-landing__filters').toggleClass('collapsed');
      });

      // Subfilter filtering
      $subfilters.on('click', function (e) {
        // DOM
        var $this = $(this);
        var $toHide = $();
        var $toShow = $();
        // LOGIC
        var label = $this.html();
        var videoSubclass = $this.data('filter-id'); // Special case for video
        var brandStory; // Special case for brand stories
        var targetStory;

        e.preventDefault();

        // Do not run if animation is still running
        if (animatingShow || animatingHide) {
          return;
        }

        // Checking through ~266 tiles
        $landingTiles.each(function () {
          // DOM
          var $this = $(this);
          var $labels = $this.find('.text--short');
          // LOGIC
          var hasLabel = false;

          if ($filters.filter('.term-active').data('filter-id') === 'ee-term4') {
            brandStory = label.toLowerCase();
          }

          if (!$this.hasClass('ee-landing__tile--sharequote')) {
            if ($labels.length !== 0) {
              hasLabel = $labels.html().search(label) > -1;

              if (hasLabel) {
                $toShow = $toShow.add($this);
              }
            }

            // Look for video subclass regardless of label
            if ($this.hasClass(videoSubclass)) {
              $toShow = $toShow.add($this);
            }

            // Look for brand story title regardless of label
            if (typeof brandStory !== 'undefined') {
              targetStory = $this.find('h4').html().toLowerCase();
              if (targetStory === brandStory) {
                $toShow = $toShow.add($this);
              }
            }
          }
        });

        $toHide = $landingTiles.not($toShow);

        showHide($toShow, $toHide);
      });

      // expand / contract
      $('.es-landing__trigger-open').on('click', function (e) {
        e.preventDefault();
        $side_filters_wrapper.addClass('expanded');
        $side_filters_wrapper.removeClass('collapsed');
      });

      $('.es-landing__trigger-close').on('click', function (e) {
        e.preventDefault();
        $side_filters_wrapper.addClass('collapsed');
        $side_filters_wrapper.removeClass('expanded');
      });

      // Copied from sites/esteelauder/modules/custom/esteelauder_estee_edit/templates/ee_landing_formatter_v1/ee_landing_formatter_v1.js
      window.onscroll = navScroll;

      function navScroll() {
      // LOGIC
        var $offset = $filters.offset();
        var $nav_bottom = $offset.top + $filters.height();
        var $page_offset = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset;

        if ($nav_bottom <= $page_offset) {
          $side_filters_wrapper.removeClass('off-side');
          $backtoTop.addClass('back-to-top-show');
        } else {
          $side_filters_wrapper.addClass('off-side');
          $backtoTop.removeClass('back-to-top-show');
        }

        // scale the logo as soon as scrolling begins
        if ($(window).scrollTop() > 0) {
          $pc__carousel_logo.addClass('logo-scale');
        } else {
          $pc__carousel_logo.removeClass('logo-scale');
        }
      }

      // mobile - disable opening video links in overlay
      $('.device-mobile').find('.ee-landing-tile__content').find('.video-launcher').removeClass('cboxElement');
      $backtoTop.click(function (e) {
        $('html, body').animate({ scrollTop: 0 }, Drupal.ELB.ui.back_top_duration);
      });

      // EE landing sharable quotes
      $('.ee-quote-share__trigger').click(function (e) {
      // DOM
        var $this = $(this);
        // LOGIC
        var $sharepop = $this.parents('.ee-landing__tile--sharequote').find('.ee-quote-share').attr('id');

        e.preventDefault();

        $this.colorbox({
          href: '#' + $sharepop,
          inline: true,
          className: 'colorbox--social-share',
          width: '320px',
          height: '200px'
        });
      });
    }
  };
}(jQuery));
